<mat-form-field appearance="fill">
  <mat-label>{{ ctx.placeholder }}</mat-label>
  <mat-select class="material-select" [formControl]="ctx.control" [compareWith]="compareOptions">
    <mat-option *ngFor="let option of ctx.options | async" [value]="option"> {{ getTitle(option) }} </mat-option>
  </mat-select>
</mat-form-field>
